import React, { useState, useEffect } from 'react';

const MinecraftLauncherWebsite = () => {
  const [currentBanner, setCurrentBanner] = useState(0);

  const banners = [
    {
      title: "Minecraft Modding Made Simple",
      subtitle: "One-click installs, automatic dependency resolution, and compatibility checks",
      icon: "🔧",
      features: ["SAT solver optimization", "Heuristic compatibility", "No mod loader hassles"]
    },
    {
      title: "Community Marketplace",
      subtitle: "Buy, sell, and share structures, skins, worlds, and servers - convert to real money",
      icon: "🛒",
      features: ["Monetize your creations", "User-generated content", "Instant purchases"]
    },
    {
      title: "Social Gaming Features",
      subtitle: "Game invites, parties, and seamless multiplayer through EOS integration",
      icon: "👥",
      features: ["EOS integration", "Party system", "Game invites"]
    },
    {
      title: "Always-On P2P Worlds",
      subtitle: "24/7 accessible worlds with automatic backups and server rentals",
      icon: "🖥️",
      features: ["24/7 world access", "Automatic backups", "Server rentals"]
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentBanner((prev) => (prev + 1) % banners.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const nextBanner = () => {
    setCurrentBanner((prev) => (prev + 1) % banners.length);
  };

  const prevBanner = () => {
    setCurrentBanner((prev) => (prev - 1 + banners.length) % banners.length);
  };

  const styles = {
    container: {
      minHeight: '100vh',
      background: '#374151',
      color: 'white',
      fontFamily: 'system-ui, -apple-system, sans-serif'
    },
    nav: {
      position: 'fixed',
      top: 0,
      width: '100%',
      zIndex: 50,
      backdropFilter: 'blur(16px)',
      backgroundColor: 'rgba(17, 24, 39, 0.2)',
      borderBottom: '1px solid rgba(55, 65, 81, 0.3)',
      padding: '1rem 1.5rem'
    },
    navContent: {
      maxWidth: '1280px',
      margin: '0 auto',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    logo: {
      fontSize: '1.5rem',
      fontWeight: 'bold'
    },
    navLinks: {
      display: 'flex',
      gap: '2rem'
    },
    navLink: {
      color: 'white',
      textDecoration: 'none',
      transition: 'color 0.2s',
      cursor: 'pointer'
    },
    downloadBtn: {
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
      backdropFilter: 'blur(4px)',
      border: '1px solid rgba(255, 255, 255, 0.2)',
      padding: '0.5rem 1.5rem',
      borderRadius: '0.5rem',
      color: 'white',
      cursor: 'pointer',
      transition: 'all 0.2s'
    },
    constructionBanner: {
      position: 'fixed',
      top: '64px',
      width: '100%',
      zIndex: 40,
      backgroundColor: 'rgba(251, 191, 36, 0.2)',
      backdropFilter: 'blur(4px)',
      borderBottom: '1px solid rgba(251, 191, 36, 0.3)',
      textAlign: 'center',
      padding: '0.5rem'
    },
    constructionContent: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '0.5rem'
    },
    heroSection: {
      paddingTop: '6rem',
      paddingBottom: '3rem',
      padding: '6rem 1.5rem 3rem'
    },
    heroContainer: {
      maxWidth: '1280px',
      margin: '0 auto'
    },
    bannerCard: {
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      backdropFilter: 'blur(16px)',
      border: '1px solid rgba(255, 255, 255, 0.1)',
      borderRadius: '1.5rem',
      padding: '3rem',
      marginBottom: '2rem',
      minHeight: '500px',
      display: 'flex',
      alignItems: 'center'
    },
    bannerControls: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: '2rem'
    },
    bannerBtn: {
      padding: '0.5rem',
      borderRadius: '50%',
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
      border: 'none',
      color: 'white',
      cursor: 'pointer',
      fontSize: '1.5rem'
    },
    bannerDots: {
      display: 'flex',
      gap: '0.5rem'
    },
    dot: {
      width: '8px',
      height: '8px',
      borderRadius: '50%',
      transition: 'all 0.2s'
    },
    bannerGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
      gap: '3rem',
      alignItems: 'center'
    },
    bannerIcon: {
      fontSize: '3rem',
      marginBottom: '1.5rem',
      color: '#d1d5db'
    },
    bannerTitle: {
      fontSize: '3rem',
      fontWeight: 'bold',
      marginBottom: '1.5rem',
      lineHeight: '1.2'
    },
    bannerSubtitle: {
      fontSize: '1.25rem',
      color: '#d1d5db',
      marginBottom: '2rem'
    },
    featuresList: {
      marginBottom: '2rem'
    },
    feature: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '0.75rem'
    },
    featureDot: {
      width: '8px',
      height: '8px',
      backgroundColor: 'white',
      borderRadius: '50%',
      marginRight: '0.75rem'
    },
    primaryBtn: {
      backgroundColor: 'white',
      color: '#374151',
      padding: '1rem 2rem',
      borderRadius: '0.5rem',
      fontWeight: '600',
      border: 'none',
      cursor: 'pointer',
      fontSize: '1rem'
    },
    placeholder: {
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      backdropFilter: 'blur(4px)',
      border: '1px solid rgba(255, 255, 255, 0.1)',
      borderRadius: '1rem',
      padding: '2rem',
      height: '320px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#9ca3af'
    },
    section: {
      padding: '5rem 1.5rem'
    },
    sectionTitle: {
      fontSize: '2.5rem',
      fontWeight: 'bold',
      textAlign: 'center',
      marginBottom: '4rem'
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
      gap: '2rem',
      maxWidth: '1280px',
      margin: '0 auto'
    },
    card: {
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      backdropFilter: 'blur(16px)',
      border: '1px solid rgba(255, 255, 255, 0.1)',
      borderRadius: '1rem',
      padding: '2rem',
      transition: 'all 0.2s'
    },
    cardIcon: {
      fontSize: '2rem',
      marginBottom: '1rem',
      color: '#d1d5db'
    },
    cardTitle: {
      fontSize: '1.25rem',
      fontWeight: '600',
      marginBottom: '1rem'
    },
    cardText: {
      color: '#d1d5db'
    },
    marketplaceSection: {
      padding: '5rem 1.5rem',
      backgroundColor: 'rgba(255, 255, 255, 0.05)'
    },
    marketplaceGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
      gap: '2rem',
      maxWidth: '1280px',
      margin: '0 auto'
    },
    marketplaceCard: {
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
      backdropFilter: 'blur(16px)',
      border: '1px solid rgba(255, 255, 255, 0.1)',
      borderRadius: '1rem',
      padding: '1.5rem',
      textAlign: 'center'
    },
    marketplaceIcon: {
      width: '64px',
      height: '64px',
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 auto 1rem',
      fontSize: '2rem'
    },
    downloadSection: {
      padding: '5rem 1.5rem',
      textAlign: 'center'
    },
    downloadCard: {
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      backdropFilter: 'blur(16px)',
      border: '1px solid rgba(255, 255, 255, 0.1)',
      borderRadius: '1.5rem',
      padding: '3rem',
      maxWidth: '1024px',
      margin: '0 auto'
    },
    downloadGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
      gap: '2rem',
      alignItems: 'center'
    },
    requirements: {
      textAlign: 'left'
    },
    requirementsList: {
      color: '#d1d5db',
      lineHeight: '1.6'
    },
    secondaryBtn: {
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
      backdropFilter: 'blur(4px)',
      border: '1px solid rgba(255, 255, 255, 0.2)',
      padding: '1rem 3rem',
      borderRadius: '0.5rem',
      color: 'white',
      cursor: 'pointer',
      width: '100%',
      marginTop: '1rem'
    },
    footer: {
      padding: '3rem 1.5rem',
      borderTop: '1px solid rgba(55, 65, 81, 0.3)'
    },
    footerGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
      gap: '2rem',
      maxWidth: '1280px',
      margin: '0 auto'
    },
    footerTitle: {
      fontSize: '1.25rem',
      fontWeight: 'bold',
      marginBottom: '1rem'
    },
    footerLinks: {
      color: '#9ca3af',
      lineHeight: '1.8'
    },
    footerBottom: {
      borderTop: '1px solid rgba(55, 65, 81, 0.3)',
      marginTop: '2rem',
      paddingTop: '2rem',
      textAlign: 'center',
      color: '#9ca3af'
    }
  };

  return (
    <div style={styles.container}>
      {/* Navigation */}
      <nav style={styles.nav}>
        <div style={styles.navContent}>
          <div style={styles.logo}>0x11 Studio</div>
          <div style={styles.navLinks}>
            <a href="#features" style={styles.navLink}>Features</a>
            <a href="#marketplace" style={styles.navLink}>Marketplace</a>
            <a href="#download" style={styles.navLink}>Download</a>
            <a href="#support" style={styles.navLink}>Support</a>
          </div>
          <button style={styles.downloadBtn}>
            ⬇️ Download
          </button>
        </div>
      </nav>

      {/* Under Construction Banner */}
      <div style={styles.constructionBanner}>
        <div style={styles.constructionContent}>
          <span style={{color: '#fbbf24'}}>🔧</span>
          <span style={{color: '#fbbf24', fontWeight: '500'}}>Under Construction</span>
          <span style={{color: '#fde047'}}>- Launcher coming soon!</span>
        </div>
      </div>

      {/* Hero Banner with Rotation */}
      <section style={styles.heroSection}>
        <div style={styles.heroContainer}>
          <div style={styles.bannerCard}>
            <div style={{width: '100%'}}>
              <div style={styles.bannerControls}>
                <button style={styles.bannerBtn} onClick={prevBanner}>
                  ◀
                </button>
                <div style={styles.bannerDots}>
                  {banners.map((_, index) => (
                    <div
                      key={index}
                      style={{
                        ...styles.dot,
                        backgroundColor: index === currentBanner ? 'white' : 'rgba(255, 255, 255, 0.3)'
                      }}
                    />
                  ))}
                </div>
                <button style={styles.bannerBtn} onClick={nextBanner}>
                  ▶
                </button>
              </div>

              <div style={styles.bannerGrid}>
                <div>
                  <div style={styles.bannerIcon}>
                    {banners[currentBanner].icon}
                  </div>
                  <h1 style={styles.bannerTitle}>
                    {banners[currentBanner].title}
                  </h1>
                  <p style={styles.bannerSubtitle}>
                    {banners[currentBanner].subtitle}
                  </p>
                  <div style={styles.featuresList}>
                    {banners[currentBanner].features.map((feature, index) => (
                      <div key={index} style={styles.feature}>
                        <div style={styles.featureDot}></div>
                        <span style={{color: '#d1d5db'}}>{feature}</span>
                      </div>
                    ))}
                  </div>
                  <button style={styles.primaryBtn}>
                    ⬇️ Download Now
                  </button>
                </div>
                <div style={styles.placeholder}>
                  [Screenshot Placeholder]
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Overview */}
      <section id="features" style={styles.section}>
        <h2 style={styles.sectionTitle}>Why Choose 0x11 Studio?</h2>
        <div style={styles.grid}>
          <div style={styles.card}>
            <div style={styles.cardIcon}>🔧</div>
            <h3 style={styles.cardTitle}>Smart Mod Management</h3>
            <p style={styles.cardText}>Advanced SAT solver and heuristics handle all dependencies and compatibility automatically.</p>
          </div>
          <div style={styles.card}>
            <div style={styles.cardIcon}>💰</div>
            <h3 style={styles.cardTitle}>Monetized Marketplace</h3>
            <p style={styles.cardText}>Create and sell structures, skins, worlds, and servers. Convert earnings to real money.</p>
          </div>
          <div style={styles.card}>
            <div style={styles.cardIcon}>👥</div>
            <h3 style={styles.cardTitle}>Social Features</h3>
            <p style={styles.cardText}>EOS integration brings game invites, parties, and seamless multiplayer experiences.</p>
          </div>
          <div style={styles.card}>
            <div style={styles.cardIcon}>⏰</div>
            <h3 style={styles.cardTitle}>Always-On Worlds</h3>
            <p style={styles.cardText}>24/7 P2P worlds with automatic backups and flexible server rental options.</p>
          </div>
        </div>
      </section>

      {/* Marketplace Section */}
      <section id="marketplace" style={styles.marketplaceSection}>
        <div style={{textAlign: 'center', marginBottom: '4rem'}}>
          <h2 style={styles.sectionTitle}>Community Marketplace</h2>
          <p style={{fontSize: '1.25rem', color: '#d1d5db'}}>Turn your creativity into income</p>
        </div>
        <div style={styles.marketplaceGrid}>
          <div style={styles.marketplaceCard}>
            <div style={styles.marketplaceIcon}>🏗️</div>
            <h3 style={{fontSize: '1.125rem', fontWeight: '600', marginBottom: '0.5rem'}}>Structures</h3>
            <p style={{color: '#d1d5db', fontSize: '0.875rem'}}>Share and sell custom builds</p>
          </div>
          <div style={styles.marketplaceCard}>
            <div style={styles.marketplaceIcon}>👤</div>
            <h3 style={{fontSize: '1.125rem', fontWeight: '600', marginBottom: '0.5rem'}}>Skins</h3>
            <p style={{color: '#d1d5db', fontSize: '0.875rem'}}>Custom character designs</p>
          </div>
          <div style={styles.marketplaceCard}>
            <div style={styles.marketplaceIcon}>🌍</div>
            <h3 style={{fontSize: '1.125rem', fontWeight: '600', marginBottom: '0.5rem'}}>Worlds</h3>
            <p style={{color: '#d1d5db', fontSize: '0.875rem'}}>Complete game worlds</p>
          </div>
          <div style={styles.marketplaceCard}>
            <div style={styles.marketplaceIcon}>🖥️</div>
            <h3 style={{fontSize: '1.125rem', fontWeight: '600', marginBottom: '0.5rem'}}>Servers</h3>
            <p style={{color: '#d1d5db', fontSize: '0.875rem'}}>Configured server setups</p>
          </div>
        </div>
      </section>

      {/* Download Section */}
      <section id="download" style={styles.downloadSection}>
        <h2 style={styles.sectionTitle}>Ready to Start?</h2>
        <p style={{fontSize: '1.25rem', color: '#d1d5db', marginBottom: '3rem'}}>Join the next generation of Minecraft modding</p>
        <div style={styles.downloadCard}>
          <div style={styles.downloadGrid}>
            <div style={styles.requirements}>
              <h3 style={{fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem'}}>System Requirements</h3>
              <div style={styles.requirementsList}>
                <p>• Windows 10/11, macOS 10.14+, or Linux</p>
                <p>• 4GB RAM minimum, 8GB recommended</p>
                <p>• Java 17 or higher</p>
                <p>• Internet connection required</p>
              </div>
            </div>
            <div>
              <button style={{...styles.primaryBtn, width: '100%', marginBottom: '1rem'}}>
                ⬇️ Download for Windows
              </button>
              <button style={styles.secondaryBtn}>
                Other Platforms
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer style={styles.footer}>
        <div style={styles.footerGrid}>
          <div>
            <h3 style={styles.footerTitle}>0x11 Studio</h3>
            <p style={{color: '#9ca3af'}}>Next-generation Minecraft launcher with advanced modding and social features.</p>
          </div>
          <div>
            <h4 style={styles.footerTitle}>Product</h4>
            <div style={styles.footerLinks}>
              <p>Features</p>
              <p>Marketplace</p>
              <p>Download</p>
              <p>System Requirements</p>
            </div>
          </div>
          <div>
            <h4 style={styles.footerTitle}>Support</h4>
            <div style={styles.footerLinks}>
              <p>Documentation</p>
              <p>FAQ</p>
              <p>Contact</p>
              <p>Community</p>
            </div>
          </div>
          <div>
            <h4 style={styles.footerTitle}>Company</h4>
            <div style={styles.footerLinks}>
              <p>About</p>
              <p>Privacy Policy</p>
              <p>Terms of Service</p>
            </div>
          </div>
        </div>
        <div style={styles.footerBottom}>
          <p>&copy; 2025 0x11 Studio. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default MinecraftLauncherWebsite;